module.exports = __webpack_public_path__ + "static/media/orangeFish.8fb8f6f2.svg";